<template>
    <router-link :to="to">
        <div class="add">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path fill="white" d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/>
            </svg>
        </div>
        <span>
            {{ label }}
        </span>
    </router-link>
</template>

<script>
    export default {
        name: "RichAddLink",
        props:{
            to: Object,
            label: String,
        }
    }
</script>

<style scoped lang="scss">
    a{
        display:flex;
        line-height: 24px;
        color:var(--color-primary);
        padding: 8px 0;
        border-radius: 8px;
        &:hover{
            background: var(--color-grey-light-2);
        }
    }

    .add {
        margin-right: 6px;
        height:24px;
        width: 24px;
        background: var(--color-primary);
        border-radius: 100%;
        display:flex;
        align-items: center;
        justify-content: center;
    }

    @include screen-xs{
        a{
            padding: 8px 16px;
        }
    }
</style>
